import React from 'react';
import styled from 'styled-components';
import checkmark from '@catalogo/ui-americanas-desktop-svg/checkmark.svg';

export const FormCheckbox = ({ onClick }) => (
  <Label>
    <Input onClick={onClick} type="checkbox" />
    <Check />
  </Label>
);

const Label = styled.label`
  width: 27px;
  height: 25px;
  margin: 8px;
  cursor: pointer;
  display: inline-block;
  position: relative;
`;

const Input = styled.input`
  width: 20px;
  height: 19px;
  appearance: none;
  border-radius: 2px;
  background-color: #fff;
  border: 1px solid ${({ theme }) => theme.grey.darker};

  &:checked {
    border: none;
    background-color: ${({ theme }) => theme.primaryColor};
  }
`;

const Check = styled(checkmark)`
  fill: white;
  width: 20px;
  height: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  path {
    stroke-width: 10px;
  }
`;

export default FormCheckbox;
